/**
 * MVP billing config (paywall bridge).
 *
 * Until Stripe/webhooks (BAB-72) land, Pro is collected manually via PayPal and
 * enabled by hand (internal `set-user-tier` endpoint). This is the link shown in
 * the upgrade modal / pricing page when a trial ends.
 *
 * The `/249` suffix prefills the Pro annual amount on the PayPal.Me page so the
 * payer can't fat-finger it. Override the whole URL via REACT_APP_PAYPAL_URL.
 */
export const PAYPAL_ME_URL =
  process.env.REACT_APP_PAYPAL_URL || 'https://paypal.me/laurenttironi/249';

/** Pro annual price, kept in one place for copy. */
export const PRO_PRICE_LABEL = '$249/yr';
